import { render, staticRenderFns } from "./DepartmentComponent.vue?vue&type=template&id=9b08c71c&scoped=true&"
import script from "./DepartmentComponent.vue?vue&type=script&lang=ts&"
export * from "./DepartmentComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentComponent.vue?vue&type=style&index=0&id=9b08c71c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b08c71c",
  null
  
)

export default component.exports